import { useLanguage } from "../i18n/LanguageContext";

export const EditorialRibbon = () => {
  const { t } = useLanguage();
  const items = [...t.ribbon, ...t.ribbon];
  return (
    <div className="border-y border-[#E7DFD5] bg-[#FFF3EB]/60 py-5 overflow-hidden" data-testid="editorial-ribbon">
      <div className="flex w-max animate-marquee gap-24 items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-24 text-xs sm:text-sm font-mono uppercase tracking-[0.25em] text-[#5F6368] whitespace-nowrap">
            {item}
            <span className="w-1.5 h-1.5 rounded-full bg-[#C85A17] inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
